import type { Minigame, MinigameType } from '.';
import { action } from '@play-co/replicant';
import { defineActions } from '../utils';

export const minigameActions = (
  Minigame: Pick<Minigame, 'ruleset' | 'schema'>,
  { Inventory }: Minigame['$DEPENDENCIES'],
) =>
  defineActions<Minigame>()({
    startMinigame: action((state, type: MinigameType, api) => {
      const energyRequired = Minigame.ruleset.getEnergyRequirement(type);
      const now = api.date.now();

      const oldCurrencies = Inventory.getters(state).getCurrencies(now);
      Inventory.modifiers(state).consumeEnergy(energyRequired, now);

      api.sendAnalyticsEvents([
        Inventory.ruleset.getCurrencyGrantEvent(
          {
            feature: 'minigame_play',
            $subFeature: 'match3',
          },
          {
            old: oldCurrencies,
            new: Inventory.getters(state).getCurrencies(now),
          },
        ),
      ]);

      // Increment minigame counter
      state.minigame.minigameCount += 1;
    }),

    setMinigameShown: action((state) => {
      state.minigame.minigameShown = true;
    }),
  });
